module.exports = __webpack_public_path__ + "static/media/26UNRWA25.8f4300c4.jpg";